import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import Hotjar from "@hotjar/browser";

import "hammerjs";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

const siteId = environment.hotjarSiteId;
const hotjarVersion = environment.hotjarVersion;

Hotjar.init(siteId, hotjarVersion);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
